import { client } from "@/index";
import { potionsLocalStorage } from "@/services/LocalStorage/localStorage";
import { userChangeSite } from "@/services/redux/actions";
import { RootState } from "@/services/redux/store";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GET_ORGANISATION_AND_SITE } from "./requests";
import { IHasPages } from "@/utils/types/component";
import { useLocation } from "react-router";
import { useHasProperty } from "@/hooks";

const RedirectionWrapper: React.FC<IHasPages> = ({ children }) => {
  const dispatch = useDispatch();
  const storedSiteId = useSelector((state: RootState) => state.site.siteId);
  const isLoggedIn = useSelector((state: RootState) => state.login.isLoggedIn);
  const location = useLocation();
  const { hasBuilder } = useHasProperty();

  const [first, organisationId, siteId, ...others] =
    location.pathname.split("/");

  const changeSite = () => {
    client
      .query({
        query: GET_ORGANISATION_AND_SITE,
        variables: { siteId: parseInt(siteId) },
      })
      .then((res) => {
        const organisation = res?.data?.site?.company;
        const site = res?.data?.site;
        potionsLocalStorage.set("organisationId", organisation?.id);
        potionsLocalStorage.set("siteId", siteId);
        potionsLocalStorage.set("organisationName", organisation?.name);
        potionsLocalStorage.set("siteName", site?.name);

        dispatch(
          userChangeSite(
            siteId,
            site?.name,
            organisation?.id,
            organisation?.name
          )
        );

        const search = window.location.search;
        const rest = location.pathname.split("/").slice(3).filter(Boolean);
        const tail =
          rest.length === 0
            ? hasBuilder
              ? ["recommendations", "site"]
              : ["home"]
            : rest;
        const newPath = ["", organisation.id, siteId, ...tail].join("/");
        // Only reload when the target path actually differs, otherwise the
        // dispatch above is enough and we avoid a redundant full reload.
        if (newPath !== window.location.pathname) {
          window.location.href = `${window.location.origin}${newPath}${search}`;
        }
      });
  };

  useEffect(() => {
    if (isLoggedIn && !!siteId && siteId !== storedSiteId) {
      changeSite();
    }
  }, [siteId, isLoggedIn]);

  return <>{children}</>;
};

export default RedirectionWrapper;
